import ReferenceType from "$types/ReferenceType";

const { ORDER, PRODUCT } = ReferenceType;

export const REFERENCE_TYPE_LABELS = {
  [ORDER]: "à la réception",
  [PRODUCT]: "à l'article",
};
